import React from "react";

export const SubmitButton = ({
  isDisabled = false,
  isLoading = false,
  loadingText = "Loading...",
  text = "Submit",
  onClick,
  type = "submit",
}) => {
  const isActive = !isDisabled && !isLoading;

  return (
    <>
      <button
        type={type}
        disabled={isDisabled || isLoading}
        onClick={onClick}
        style={{
          width: "100%",
          height: "48px",
          fontSize: "16px",
          fontWeight: "600",
          borderRadius: "8px",
          border: "2px solid",
          cursor: isActive ? "pointer" : "not-allowed",
          transition: "all 0.3s ease",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "10px",
          backgroundColor: isLoading
            ? "#7c3aed"
            : isActive
            ? "white"
            : "#f9fafb",
          color: isLoading ? "white" : isActive ? "#7c3aed" : "#9ca3af",
          borderColor: isLoading ? "#7c3aed" : isActive ? "#7c3aed" : "#e5e7eb",
          boxShadow: isActive ? "0 1px 2px rgba(124, 58, 237, 0.1)" : "none",
        }}
      >
        {isLoading ? (
          <>
            <svg
              style={{
                animation: "spin 1s linear infinite",
                width: "20px",
                height: "20px",
              }}
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                style={{ opacity: 0.25 }}
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              />
              <path
                style={{ opacity: 0.75 }}
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
            {loadingText}
          </>
        ) : (
          text
        )}
      </button>
    </>
  );
};
